import { BaseTableContentViewModel } from '../../baseTableContentViewModel';
import { TableContentItem } from '../../interface/tableContentItems';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { TableContentViewModel } from '@/viewModels/tableContent';
import { UniqueHeaderKey } from '../../interface/tableContentHeaders';

/**
 * -
 */
export class UniqueTableContentViewModel extends BaseTableContentViewModel {
  /**
   * -
   * @param headerKey -
   */
  public uniqueHeader = (headerKey: UniqueHeaderKey): string => {
    switch (headerKey) {
      case 'Space8px':
        return '';
      default:
        return '';
    }
  };
  /**
   * -
   * @param headerKey -
   * @param item -
   */
  public displayUniqueItem = (headerKey: UniqueHeaderKey, item: TableContentItem): string => {
    switch (headerKey) {
      case 'Space8px':
        return '';
      default:
        return '';
    }
  };
}
